/* SCROLL LENIS */
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const lenis = new Lenis({
        smooth: true,
        smoothWheel: true,
        syncTouch: false,
        syncTouchLerp: 0.1,
        duration: 1.9,
        lerp: 0.08
      })
      
      lenis.on('scroll', (e) => {
        // console.log(e)
      })
      
      function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
      }
      
      requestAnimationFrame(raf)
    }, 1000); 
  });
/* END SCROLL LENIS */
/* SPLITTING */
  document.addEventListener('DOMContentLoaded', function() {
  	Splitting();
  });
/* SPLITTING */
/* CURRENT YEAR */
  document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll(".current-year").forEach(element => {
          element.textContent = new Date().getFullYear();
      });
  });
/* END CURRENT YEAR */

/* EFFECT BEANS */
  document.addEventListener("DOMContentLoaded", function () {
    const navItems = document.querySelectorAll("._nav .nav-item > a");
    const bean = document.querySelector(".bean-i");

    function moveBeanTo(el) {
      const rect = el.getBoundingClientRect();
      const navRect = el.closest("._nav").getBoundingClientRect();

      const width = rect.width;
      const height = rect.height;
      const left = rect.left - navRect.left;
      const top = rect.top - navRect.top;

      bean.style.width = width + "px";
      bean.style.height = height + "px";
      bean.style.left = left + "px";
      bean.style.top = top + "px";
    }

    // Al hacer hover
    navItems.forEach(link => {
      link.addEventListener("mouseenter", () => moveBeanTo(link));
    });

    // Al cargar la página, mover al item activo si hay
    const activeItem = document.querySelector("._nav .current > a");
    if (activeItem) moveBeanTo(activeItem);
  });
/* END EFFECT BEAN */

/* GRADIENT BTN */

(() => {
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  document.querySelectorAll('.btn-i').forEach((btn) => {
    const grad = btn.querySelector('.gradient-i');
    if (!grad) return;

    let rect, halfW, halfH, active = false;

    const measure = () => {
      rect = btn.getBoundingClientRect();
      const g = grad.getBoundingClientRect(); // respeta tamaños en vw/vh
      halfW = g.width * 0.5 || grad.offsetWidth * 0.5;
      halfH = g.height * 0.5 || grad.offsetHeight * 0.5;
    };

    const moveNow = (e) => {
      if (!active || !rect) return;

      const x = e.clientX - rect.left;   // pos dentro del botón
      const y = e.clientY - rect.top;

      const cx = clamp(x, halfW, rect.width  - halfW); // centro clamped
      const cy = clamp(y, halfH, rect.height - halfH);

      // Evita left/top: usa transform (GPU). Top/left quedan en 0.
      grad.style.transform = `translate3d(${cx - halfW}px, ${cy - halfH}px, 0)`;
    };

    const onEnter = (e) => {
      active = true;

      // Asegura contexto de posicionamiento correcto
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      if (getComputedStyle(grad).position === 'static') grad.style.position = 'absolute';

      // El gradiente parte en 0,0 y solo lo movemos con transform
      grad.style.left = '0';
      grad.style.top  = '0';

      measure();
      moveNow(e);
    };

    const onLeave = () => {
      active = false;
      // Si quieres “volver al centro”, descomenta:
      // grad.style.transform = `translate3d(${rect.width/2 - halfW}px, ${rect.height/2 - halfH}px, 0)`;
    };

    btn.addEventListener('mouseenter', onEnter, { passive: true });
    btn.addEventListener('mousemove',  moveNow, { passive: true });
    btn.addEventListener('mouseleave', onLeave,  { passive: true });
    window.addEventListener('resize', measure);
  });
})();

/* END GRADIENT BTN */






(() => {
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const docEl = document.documentElement;

  // === NUEVO: soportar los 3 headers ===
  const HEADER_SELECTORS = ['#shopify-section-head', '#shopify-section-head-i', '#shopify-section-head-ii'];
  const HEADER_SELECTOR  = HEADER_SELECTORS.join(', ');

  // Fuerza estado inicial si falta
  const ensureState = (el) => {
    if (!el.classList.contains('on') && !el.classList.contains('off')) el.classList.add('off');
  };

  // Aplica .on/.off y ARIA; evita "matar" el header con inert
  const setOn = (el, on) => {
    el.classList.toggle('on',  on);
    el.classList.toggle('off', !on);

    // === AJUSTE: aplica a cualquiera de los 3 headers ===
    if (el.matches(HEADER_SELECTOR)) {
      el.setAttribute('aria-hidden', String(!on));
      // (no usar inert aquí)
    }
    if (el.matches('.bigmenu-i')) {
      el.setAttribute('aria-hidden', String(!on));
      if (!on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    }
    if (el.matches('.bgmenu-i')) {
      el.setAttribute('aria-hidden', String(!on));
    }
    if (el.matches('.backmenu-i')) {
      el.setAttribute('aria-hidden', String(!on));
    }
    if (el.matches('.btnactivemenu')) {
      el.setAttribute('aria-expanded', String(on));
      el.setAttribute('aria-pressed',  String(on));
    }
  };

  // 🔒 Cierra cualquier collapse abierto dentro del mega menú
  const closeMenuCollapses = () => {
    const selector = 'section.bigmenu-i .collapse.show, .bigmenu-i .collapse.show';
    const openCollapses = $$(selector);

    openCollapses.forEach(el => {
      const BS = window.bootstrap && window.bootstrap.Collapse;
      if (BS) {
        try {
          const inst = BS.getInstance ? BS.getInstance(el) : null;
          (inst || new BS(el, { toggle: false })).hide();
          return;
        } catch (_) { /* fallback abajo */ }
      }
      el.classList.remove('show', 'collapsing');
      el.style.height = '';
      el.style.display = '';
      el.setAttribute('aria-hidden', 'true');
    });

    const togglers = $$('section.bigmenu-i [data-bs-toggle="collapse"][aria-expanded="true"], .bigmenu-i [data-bs-toggle="collapse"][aria-expanded="true"]');
    togglers.forEach(btn => {
      btn.classList.add('collapsed');
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  const getGroup = () => {
    // === AJUSTE: traer todos los headers que existan ===
    const head     = $$(HEADER_SELECTOR);
    const menu     = $$('.bigmenu-i');
    const bgmenu   = $$('.bgmenu-i');
    const backdrop = $$('.backmenu-i');
    const toggles  = $$('.btnactivemenu');
    return { head, menu, bgmenu, backdrop, toggles, all: [...head, ...menu, ...bgmenu, ...backdrop, ...toggles] };
  };

  // Init
  getGroup().all.forEach(ensureState);

  const isOpen = () => docEl.classList.contains('menu-open');

  const setAll = (force) => {
    const group = getGroup();
    const next = typeof force === 'boolean' ? force : !isOpen();
    group.all.forEach(el => setOn(el, next));
    docEl.classList.toggle('menu-open', next);

    if (!next) closeMenuCollapses();
  };

  // Toggle por cualquier .btnactivemenu (delegado)
  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest('.btnactivemenu');
    if (!btn) return;
    ev.preventDefault();
    setAll();
  }, { passive: false });

  // Toggle por clic en .bgmenu-i
  document.addEventListener('click', (ev) => {
    const zone = ev.target.closest('.bgmenu-i');
    if (!zone) return;
    ev.preventDefault();
    setAll();
  }, { passive: false });

  // Cierre por fondo
  document.addEventListener('click', (ev) => {
    if (ev.target.closest('.backmenu-i')) setAll(false);
  });

  // Cierre por ESC
  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape' && isOpen()) setAll(false);
  });

  // Mini-API
  window.BigMenu = {
    open:  () => setAll(true),
    close: () => setAll(false),
    toggle: () => setAll(),
    state: () => (isOpen() ? 'on' : 'off')
  };
})();





/* GLOBAL ANIMATION */
$(document).ready(function () {
  const $body = $("body");
  const introDisabled = $(".home-i.home-i--intro-disabled").length > 0;

  // Homepage intro disabled:
  // jump immediately to the final intro state.
  if (introDisabled) {
    $body.addClass(
      "move-i move-ii move-iii move-iv move-v move-vi move-vii"
    );

    return;
  }

  // Check if the intro already ran during this session.
  if (sessionStorage.getItem("hasAnimated") === "true") {
    $body.addClass(
      "move-i move-ii move-iii move-iv move-v move-vi move-vii"
    );

    return;
  }

  // First visit: run the original intro sequence.
  setTimeout(function () {
    $body.addClass("move-i");

    setTimeout(function () {
      $body.addClass("move-ii");

      setTimeout(function () {
        $body.addClass("move-iii");

        setTimeout(function () {
          $body.addClass("move-iv");

          setTimeout(function () {
            $body.addClass("move-v");

            setTimeout(function () {
              $body.addClass("move-vi");

              setTimeout(function () {
                $body.addClass("move-vii");
              }, 700);
            }, 300);
          }, 5000);
        }, 1000);
      }, 0);
    }, 0);
  }, 0);

  // Mark the intro as completed for this session.
  sessionStorage.setItem("hasAnimated", "true");
});

/* Transiciones Splitting */
$(document).ready(function () {
  $(".splitting.words").each(function () {
    $(this)
      .find("span.char")
      .each(function (index) {
        var delay = (index * 0.015).toFixed(2);
        $(this).css("transition-delay", delay + "s");
      });
  });

  $(".splitting.words").each(function () {
    $(this)
      .find(".word")
      .each(function (index) {
        var delay = (index * 0.025).toFixed(2);
        $(this).css("transition-delay", delay + "s");
      });
  });
});
/* END GLOBAL ANIMATION */







(function () {
  try {
    if (window.__CartQtySync) return; 
    window.__CartQtySync = true;

    var drawerHost = document.querySelector('cart-drawer');
    var itemsRoot  = document.getElementById('CartDrawer-CartItems') || document.getElementById('CartDrawer') || document;

    function totalQty() {
      var sum = 0, els = document.querySelectorAll('#CartDrawer .quantity__input');
      for (var i = 0; i < els.length; i++) {
        var n = parseInt(els[i].value, 10);
        if (!isNaN(n)) sum += n;
      }
      return sum;
    }

    function paint(total) {
      var head = document.getElementById('CartDrawer-Count');
      if (head) head.textContent = String(total);

      var badges = document.querySelectorAll('.numbers-qty-pdps');
      for (var i = 0; i < badges.length; i++) {
        var el = badges[i];
        if (total > 0) {
          el.textContent = String(total);
          el.style.display = '';
          el.setAttribute('aria-hidden','false');
        } else {
          el.textContent = '';
          el.style.display = 'none';
          el.setAttribute('aria-hidden','true');
        }
      }
    }

    function sync() {
      var inputs = document.querySelectorAll('#CartDrawer .quantity__input');
      var empty  = (drawerHost && drawerHost.classList.contains('is-empty')) || inputs.length === 0;
      if (empty) {
        // fallback: pedir el item_count real al backend
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => paint(cart.item_count))
          .catch(() => paint(0));
      } else {
        paint(totalQty());
      }
    }

    // Primer pintado (si tu <span> trae data-initial-count del Liquid)
    var cntEl = document.getElementById('CartDrawer-Count');
    var initial = cntEl && cntEl.getAttribute ? parseInt(cntEl.getAttribute('data-initial-count') || '', 10) : NaN;
    if (!isNaN(initial)) paint(initial);
    sync();

    function schedule() { 
      Promise.resolve().then(sync); 
      setTimeout(sync, 0); 
    }

    // Instantáneo: input/change/click (+/− y eliminar)
    document.addEventListener('input',  schedule, true);
    document.addEventListener('change', schedule, true);
    document.addEventListener('click',  function(e){
      if (e.target.closest && (e.target.closest('.quantity__button') || e.target.closest('.cart-remove-button'))) {
        schedule();
      }
    }, true);

    // Re-render del Drawer (Shopify Sections)
    new MutationObserver(schedule).observe(itemsRoot, { childList: true, subtree: true });

    // Eventos del tema o de Shopify → siempre forzamos sync inmediato
    ['cart:updated','cart:change','cart:refresh','shopify:section:load'].forEach(function(ev){
      document.addEventListener(ev, function(){
        sync();
      }, true);
    });

  } catch (e) { console.warn('CartQtySync error', e); }
})();






document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("cart-drawer.drawer");
  const cart = document.getElementById("CartDrawer");

  if (!drawer || !cart) return;

  drawer.addEventListener("transitionend", (e) => {
    if (drawer.classList.contains("closing") && e.propertyName === "transform") {
      drawer.classList.remove("closing");
      drawer.style.visibility = "hidden";
    }
  });

  drawer.addEventListener("closeDrawer", () => {
    drawer.classList.remove("active");
    drawer.classList.add("closing");
    drawer.style.visibility = "visible";
  });

  drawer.addEventListener("openDrawer", () => {
    drawer.classList.remove("closing");
    drawer.classList.add("active");
    drawer.style.visibility = "visible";
  });
});





document.addEventListener("DOMContentLoaded", function () {
  const tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });
});




(function () {
  // CONFIG ---- ajusta si tu header tiene otro selector
  const headerSelector = 'header'; // ejemplo: '.site-header' o '#topbar'
  const extraMargin = 12; // px extra sobre el alto del header
  const maxWaitAttempts = 40; // para esperar a que exista el target en carga
  const waitIntervalMs = 25;

  // Encontrar instancia Lenis si existe
  function getLenis() {
    // algunas integraciones la exponen en window.lenis o window.__lenis
    return window.lenis || window.__lenis || null;
  }

  // Calcula offset del header (si no existe devuelve 0)
    function getHeaderOffset() {
      const header = document.querySelector(headerSelector);
      if (!header) return 0;
      // altura real del header (incluye padding/border visual)
      const height = header.getBoundingClientRect().height || 0;
      return Math.round(height);
    }

  // Calcula la posición vertical objetivo absoluta para desplazar
  function targetScrollPosition(el) {
    const headerOffset = getHeaderOffset();

    // posición absoluta del top del elemento respecto al documento
    const elTop = el.getBoundingClientRect().top + window.pageYOffset;

    // asegura que el elemento tenga scrollMarginTop para que quede visible bajo el header
    // (esto ayuda en navegadores que usan anclaje nativo o en casos de CSS scroll-behavior)
    try {
      el.style.scrollMarginTop = `${headerOffset}px`;
    } catch (e) {
      // noop si no se puede setear
    }

    // la posición final será el top del elemento menos la altura del header
    const y = Math.max(0, Math.round(elTop - headerOffset));
    return y;
  }

  // Ejecuta el scroll usando Lenis si está, si no usa scrollTo smooth nativo
  function smoothScrollTo(y, immediate) {
    const lenis = getLenis();
    if (lenis && typeof lenis.scrollTo === 'function') {
      // lenis.scrollTo admite un número (y) — así respetamos su motor
      // si tu versión de Lenis exige otro API, reemplaza aquí.
      try {
        lenis.scrollTo(y, { immediate: !!immediate });
      } catch (e) {
        // fallback si la API difiere
        window.scrollTo({ top: y, behavior: immediate ? 'auto' : 'smooth' });
      }
    } else {
      window.scrollTo({ top: y, behavior: immediate ? 'auto' : 'smooth' });
    }
  }

  // Scroll hacia un elemento (acepta elemento o id)
  function scrollToElement(el, immediate) {
    if (!el) return;
    const y = targetScrollPosition(el);
    smoothScrollTo(y, immediate);
  }

  // Busca elemento y scrolla; espera si aún no existe (útil en Single Page o render tardío)
  function findAndScroll(hash, immediate) {
    if (!hash) return;
    const id = decodeURIComponent(hash.replace(/^#/, ''));
    if (!id) return;
    let attempts = 0;

    return new Promise((resolve) => {
      (function tryAgain() {
        const el = document.getElementById(id) || document.querySelector(`[name="${id}"]`);
        if (el) {
          scrollToElement(el, immediate);
          resolve(true);
          return;
        }
        attempts += 1;
        if (attempts >= maxWaitAttempts) {
          resolve(false);
          return;
        }
        setTimeout(tryAgain, waitIntervalMs);
      })();
    });
  }

  // Delegated click handler para enlaces internos
  function onDocumentClick(e) {
    // Solo botón izquierdo sin modifiers
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    // Si el link tiene data-skip-smooth -> no interferimos
    if (a.hasAttribute('data-skip-smooth')) return;

    // Ignorar href="#" vacío
    const href = a.getAttribute('href');
    if (!href || href === '#') return;

    // Solo si es mismo path (mismo documento)
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.search !== location.search) return;

    // Previene comportamiento por defecto y hacemos scroll suave
    e.preventDefault();
    const hash = url.hash;
    findAndScroll(hash, false).then(() => {
      // Actualizar el hash en URL sin hacer salto (pushState evita salto inmediato)
      history.pushState(null, '', hash);
    });
  }

  // Maneja cambios de hash por back/forward o por asignación manual
  function onHashChange() {
    const hash = location.hash;
    findAndScroll(hash, false);
  }

  // Al cargar la página con hash, hacemos scroll (inmediato=false para animación)
  function onLoadHash() {
    const hash = location.hash;
    if (!hash) return;
    // Pequeño timeout para esperar CSS/layout; pero si Lenis está manejando el init, queremos esperar
    // Usamos findAndScroll que reintentará hasta que exista el elemento.
    findAndScroll(hash, false);
  }

  // Inicialización
  function init() {
    document.addEventListener('click', onDocumentClick, { passive: false });
    window.addEventListener('hashchange', onHashChange, false);
    window.addEventListener('popstate', onHashChange, false);

    // Intentar scroll automático si hay hash al cargar
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      onLoadHash();
    } else {
      window.addEventListener('DOMContentLoaded', onLoadHash, { once: true });
    }
  }

  // Auto-init
  init();

  // Exportar una API ligera por si quieres llamarlo desde consola:
  window.__smoothHashScroll = {
    scrollToId: (id) => {
      const el = document.getElementById(id) || document.querySelector(`[name="${id}"]`);
      scrollToElement(el, false);
    },
    config: {
      setHeaderSelector: (sel) => { /* no rebind headerSelector variable, but user can modify DOM or reinit */ console.warn('Para cambiar headerSelector edita el script directamente.'); },
    },
  };
})();


(() => {
  function wagonSignature() {
    console.log("");

    console.log(
      "%c────────────────────────────────────────────",
      "font-family:monospace;"
    );

    console.log(
      "%cDesigned & Developed with passion\nby Wagon Design Studio",
      "font-size:18px;font-weight:bold;"
    );

    console.log("");

    console.log(
      "%cIn collaboration with\nDaniel E. Bahamón",
      "font-size:15px;"
    );

    console.log("");

    console.log("%chttps://wagondesignstudio.com", "text-decoration:underline;");
    console.log("%chttps://bahamon.dev", "text-decoration:underline;");

    console.log("");

    console.log(
      "%c────────────────────────────────────────────",
      "font-family:monospace;"
    );
  }

  window.addEventListener("load", () => {
    setTimeout(wagonSignature, 6000);
  }, { once: true });
})();